import { RouteType } from './types';
var RouteContainer = /** @class */ (function () {
    function RouteContainer() {
        this.currentType = RouteType.PUBLIC;
        this.prefix = '';
        this.routes = [];
    }
    RouteContainer.prototype.getRoutes = function () {
        return this.routes;
    };
    RouteContainer.prototype.groupType = function (type, register) {
        this.group('', register, type);
    };
    RouteContainer.prototype.group = function (url, register, type) {
        this.currentType = type;
        this.prefix = url;
        register();
        this.prefix = '';
        this.currentType = RouteType.PUBLIC;
    };
    RouteContainer.prototype.add = function (url, component, name) {
        this.routes.push({
            path: this.prefix + url,
            component: component,
            name: name,
            type: this.currentType,
        });
    };
    RouteContainer.prototype.addType = function (url, component, name, type) {
        this.routes.push({
            path: this.prefix + url,
            component: component,
            name: name,
            type: type,
        });
    };
    return RouteContainer;
}());
export { RouteContainer };
export default RouteContainer;
